
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Luxurybushireforcorporateinpune() {



    const cardData =
    {
        keyword: 'Luxury Bus Hire for Corporate in Pune',
        heading: 'etravo :  Luxury Bus Hire for Corporate in Pune',
        headingDescription: 'eTravo offers Luxury Bus Hire for Corporate in Pune, ensuring premium travel experiences for business meetings, conferences, team outings, and high-profile corporate events. Our fleet of luxury buses features plush reclining seats, air conditioning, entertainment systems, and ample legroom—delivering comfort and class on every trip. With trained chauffeurs, real-time GPS tracking, and on-time service, we provide a seamless travel experience tailored to the needs of corporate professionals. Whether for in-city travel or outstation corporate tours, eTravo is the trusted name for reliable and luxurious group transportation in Pune.',

        top: 'Top Places to Visit in Pune with etravo',
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a majestic 18th-century fortification located in the heart of Pune. Built in 1732 by the Peshwas of the Maratha Empire, it served as their seat of power until 1818. The grand entrance, known as the Delhi Darwaza, and the intricate architecture reflect the glory of Maratha rule. Although much of the fort was destroyed in a fire in 1828, its remaining walls, gardens, and fountains still echo the stories of royal intrigue, valor, and politics. It is a must-visit for history enthusiasts and those curious about Pune’s regal heritage."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace is not just a stunning piece of architecture but also a monument of national significance. Built in 1892 by Sultan Aga Khan III, the palace is closely associated with India’s freedom movement. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. With its Italian arches, sprawling gardens, and a museum housing Gandhiji’s memorabilia, the palace provides a serene yet powerful reminder of India’s struggle for independence. It’s a place of reflection, peace, and inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, meaning 'Lion's Fort', is perched atop a rugged hill about 35 km from Pune. A site of many historical battles, it is most famous for the Battle of Sinhagad in 1670, where the Maratha warrior Tanaji Malusare fought valiantly. The fort offers panoramic views of the surrounding Sahyadri mountains and the Khadakwasla dam. A favorite among trekkers and nature lovers, the fort also features remnants of ancient gates, temples, military stables, and even food stalls offering local snacks like kanda bhaji and pithla-bhakri."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple is a hidden gem amidst Pune’s urban sprawl. Carved out of a single basalt rock in the 8th century, this ancient temple is dedicated to Lord Shiva and features beautifully sculpted pillars and a Nandi bull in the courtyard. Despite being in the middle of the bustling Jangli Maharaj Road, the temple offers a peaceful, almost timeless ambiance. Its unfinished structure adds to its mystique, making it a fascinating stop for lovers of history, architecture, and spirituality."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This museum is a treasure trove of India's rich cultural legacy. Founded by Dr. Dinkar G. Kelkar in memory of his son, the museum houses over 20,000 artifacts that span centuries. From musical instruments and antique furniture to intricate ivory carvings and everyday tools, each item tells a story of India’s diverse traditions and artistry. A full-scale replica of a traditional Maratha wada (mansion) is one of the highlights. Located in central Pune, this museum offers a deep dive into India’s folk and decorative arts."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "One of Pune’s most beloved and iconic spiritual sites, the Dagdusheth Halwai Ganapati Temple attracts thousands of devotees every day. The temple is known for its magnificent Ganesh idol, adorned with gold and fresh flowers, and its vibrant atmosphere during Ganesh Chaturthi. Built over 130 years ago by a sweet merchant named Dagdusheth Halwai, the temple is not only a center of faith but also a hub for community activities, charity, and cultural events. Its grandeur and spiritual aura make it a must-visit."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in the serene Koregaon Park area, the Osho Ashram is a global meditation hub that attracts spiritual seekers from across the world. Founded by the Indian mystic Osho, the resort offers a range of meditation techniques, wellness therapies, and personal growth workshops amidst tranquil Zen-like gardens and modern infrastructure. Visitors can enroll for day passes or longer retreats and enjoy a unique blend of spirituality, luxury, and self-discovery in one of India’s most sophisticated wellness centers."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Inspired by the Korakuen Garden of Okayama, Japan, this beautifully landscaped park, also known as the Pu La Deshpande Udyan, is a symbol of Indo-Japanese friendship. Spread across 10 acres, it features manicured lawns, flowing streams, wooden bridges, and bonsai-style trees. The garden offers a peaceful environment for walking, photography, or quiet contemplation, making it one of the most scenic urban escapes in Pune."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of the oldest heritage landmarks in Pune, rising 2,100 feet above sea level. A climb of 103 steps leads you to a group of five temples, the main one dedicated to Goddess Parvati. From the top, visitors are treated to a panoramic view of the entire city. The hill also houses a small museum and the Peshwa-era samadhis (memorials), making it a spiritual and historical site worth visiting—especially during sunrise or sunset."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Situated about 20 km from Pune, Khadakwasla Dam is a peaceful retreat that provides drinking water to the city. Surrounded by hills and greenery, it’s a favorite weekend getaway for picnics, morning walks, and watching the sunset over the backwaters. The area is also popular with cyclists and joggers. On weekends, local food stalls set up shop, offering mouthwatering Maharashtrian snacks, making it a blend of natural beauty and local flavor."
  }
],

"services": [
  {
    "name": "Luxury AC Bus Services for Businesses Pune",
    "description": "eTravo provides luxury AC bus services in Pune tailored for businesses that value comfort, style, and reliability. Perfect for executive travel, corporate events, or client transportation, our buses feature reclining seats, spacious interiors, and professional chauffeurs for a top-tier experience."
  },
  {
    "name": "Premium Bus Rental Pune",
    "description": "Elevate corporate mobility with eTravo’s premium bus rental services in Pune. Designed for business events, VIP group travel, and board-level transport, our buses offer superior comfort, clean interiors, and on-time service supported by experienced drivers and a responsive transport team."
  },
  {
    "name": "Comfortable Corporate Travel Solutions Pune",
    "description": "eTravo delivers comfortable corporate travel solutions in Pune through our fleet of premium buses and cabs. Whether for daily staff commutes or executive off-sites, our services combine comfort, punctuality, and flexibility to meet dynamic corporate needs."
  },
  {
    "name": "High-End Staff Transport in Pune",
    "description": "Ensure a premium travel experience for your team with eTravo’s high-end staff transport in Pune. Our luxury buses offer air-conditioning, plush seating, and a smooth ride, ideal for companies looking to impress clients or enhance employee satisfaction."
  },
  {
    "name": "Executive Bus on Rent Pune",
    "description": "eTravo offers executive bus rentals in Pune for business leaders, top management, and corporate delegations. These buses come equipped with extra legroom, privacy options, Wi-Fi, and trained chauffeurs—ideal for high-priority business travel requirements."
  },
  {
    "name": "Business-Class Bus Services Pune",
    "description": "Travel like an executive with eTravo’s business-class bus services in Pune. Our vehicles are designed for professionals seeking efficiency and elegance in transport, perfect for board meetings, site visits, or high-level team transfers across the city."
  },
  {
    "name": "Deluxe Bus for Corporate Use Pune",
    "description": "Choose eTravo’s deluxe buses for premium corporate use in Pune. These spacious, well-appointed vehicles are ideal for transporting employees or executives in style, complete with air-conditioning, ambient lighting, and courteous service from trained staff."
  }
],
"tableData": [
  ["Luxury AC Bus Services for Businesses Pune", "Premium Bus Rental Pune"],
  ["Comfortable Corporate Travel Solutions Pune", "High-End Staff Transport in Pune"],
  ["Executive Bus on Rent Pune", "Business-Class Bus Services Pune"],
  ["Deluxe Bus for Corporate Use Pune", ""]
],




"whychoose": [
    {
        "WhyChooseheading": "Luxury Bus Hire for Corporate Travel in Pune",
        "WhyChoosedescription": "eTravo offers top-of-the-line luxury buses for corporate travel in Pune, ideal for executive offsites, business conferences, and VIP transport. Our services are tailored to provide maximum comfort, professionalism, and reliability for business groups."
    },
    {
        "WhyChooseheading": "High-End Buses with Premium Amenities",
        "WhyChoosedescription": "Our luxury buses feature reclining leather seats, air-conditioning, onboard entertainment systems, Wi-Fi (on request), charging ports, and spacious interiors. Designed to deliver a superior travel experience for corporate teams and executives."
    },
    {
        "WhyChooseheading": "Ideal for Corporate Events and Executive Groups",
        "WhyChoosedescription": "Whether you're transporting senior management, clients, or a large corporate delegation, our luxury buses are the perfect fit. Available in various seating capacities, they ensure elegance and efficiency for business events of all sizes."
    },
    {
        "WhyChooseheading": "Professional Chauffeurs and Crew",
        "WhyChoosedescription": "Our chauffeurs are trained in corporate etiquette, uniformed, and experienced in handling VIP travel. They maintain strict punctuality and are familiar with Pune's business districts and event venues to ensure smooth operations."
    },
    {
        "WhyChooseheading": "On-Time Service with Live Tracking and Support",
        "WhyChoosedescription": "Punctuality is key in corporate travel. Our luxury buses are equipped with GPS for real-time tracking, and our operations team provides live updates and support to ensure your transport runs exactly as planned."
    },
    {
        "WhyChooseheading": "Transparent Pricing and GST-Compliant Billing",
        "WhyChoosedescription": "We offer clear pricing with no hidden costs. eTravo provides GST-compliant invoices and detailed billing reports, making it easy for businesses to manage event transport expenses and reimbursements."
    },
    {
        "WhyChooseheading": "Available 24/7 for Corporate Travel Needs",
        "WhyChoosedescription": "Our luxury buses are available any time your business needs them—whether for early departures, late-night drop-offs, or multi-day corporate tours. Our support team is on call around the clock to assist with changes or emergencies."
    },
    {
        "WhyChooseheading": "Effortless Booking via App, Website, or Phone",
        "WhyChoosedescription": "Booking a luxury bus with eTravo is fast and flexible. Use our app, website, or contact our support team for personalized coordination, instant confirmations, and smooth scheduling—all tailored to your event or business requirement."
    }
]






























    }

const faqData = [
    [
        {
            question: 'Does eTravo offer luxury bus hire for corporate clients in Pune?',
            answer: 'Yes, eTravo provides luxury buses for hire in Pune, specifically tailored for corporate travel such as executive offsites, conferences, team events, and business tours.',
        },
        {
            question: 'What features are included in your luxury buses?',
            answer: 'Our luxury buses come equipped with plush reclining seats, full air-conditioning, ambient lighting, entertainment systems, USB charging ports, Wi-Fi (optional), and onboard refreshments.',
        },
        {
            question: 'What seating capacities are available in eTravo’s luxury buses?',
            answer: 'We offer luxury buses in various sizes, including 20-seater, 35-seater, and 45+ seater models to accommodate small leadership teams or large corporate groups.',
        },
        {
            question: 'Are your luxury buses suitable for long-distance corporate travel?',
            answer: 'Absolutely. Our luxury buses are ideal for intercity and long-distance business travel from Pune to locations like Mumbai, Lonavala, Mahabaleshwar, and more — with comfort and reliability ensured.',
        },
        {
            question: 'Can we hire luxury buses for one-day corporate events or multi-day trips?',
            answer: 'Yes, you can hire our luxury buses for both short-duration events and extended multi-day corporate retreats or tours. Flexible rental packages are available.',
        },
        {
            question: 'Is staff support provided during luxury bus trips?',
            answer: 'Yes, along with trained chauffeurs, we offer optional onboard staff for guest assistance, coordination, and seamless experience during premium corporate travel.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Rohit Shelar',
        designation: 'Travel Coordinator, Zenith Finance Corp.',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s luxury bus service exceeded our expectations during our corporate offsite. The comfort, punctuality, and onboard amenities truly added value to our travel experience.”',
    },
    {
        name: 'Ms. Sneha Narang',
        designation: 'Admin Manager, SkyBridge Analytics',
        rating: [1, 1, 1, 1, 1],
        text: '“Our executive team used eTravo’s luxury coach for a high-profile corporate event in Pune. The service was premium, well-managed, and reflected our brand image perfectly.”',
    },
];




















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Bus Hire for Corporate in Pune",
  "image": "https://www.etravo.in/images/keyword/luxury-bus-hire-corporate-pune.jpg",
  "description": "Luxury AC bus rental services in Pune for corporate use by eTravo. Premium and comfortable transport for executive staff, business events, and company travel. Ideal for high-end and professional commute solutions.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6009"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/luxury-bus-hire-for-corporate-in-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Luxury Bus Hire for Corporate in Pune | Premium Executive Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire luxury AC buses in Pune for corporate travel with eTravo. Executive and business-class transport for staff, meetings, and events. Premium, comfortable, and reliable corporate bus rental service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/29.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Luxurybushireforcorporateinpune;